type BurgerMenuProps = {
  onClick: () => void;
};

export function BurgerMenu({ onClick }: BurgerMenuProps) {
  return (
    <button
      className="navbar-menu-btn btn btn-flat btn-xl btn-icon flex-center"
      type="button"
      data-bs-toggle="dropdown"
      data-bs-offset="0,4"
      aria-expanded="true"
      onClick={onClick}
    >
      <svg className="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="6" width="20" height="2" fill="currentColor"></rect>
        <rect x="2" y="11" width="20" height="2" fill="currentColor"></rect>
        <rect x="2" y="16" width="20" height="2" fill="currentColor"></rect>
      </svg>
    </button>
  );
}
